import { defineStore } from "pinia";
import { getFirebaseBackend } from '../../authUtils'
// import router from '@/router'
import { useNotificationStore } from '@/store/pinia/index'

export const useAuthStore = defineStore("auth", {
    state: () => ({
        currentUser: sessionStorage.getItem('authUser'),
    }),
    getters: {
        loggedIn() {
            // return !!this.currentUser
            return true//不用登录
        }
    }
    ,
    actions: {
        logIn({ email, password }) {
            const notificationStore = useNotificationStore()
            notificationStore.error("")

            return getFirebaseBackend().loginUser(email, password).then(() => {
                return this.validate()
            }).catch((error) => {
                notificationStore.error(error)
                throw Error(error)
            })
        },
        validate() {
            if (!this.currentUser) {
                return Promise.resolve({})
            }
            const user = getFirebaseBackend().getAuthenticatedUser()
            this.setUser(user)

            return Promise.resolve(user)

        },
        setUser(user) {
            this.currentUser = user
            this.saveState('auth.currentUser', user)


        },
        saveState(key, state) {
            window.sessionStorage.setItem(key, JSON.stringify(state))
        },
        register({ username, email, password } = {}) {
            const notificationStore = useNotificationStore()
            notificationStore.error("")
            return getFirebaseBackend().registerUser(username, email, password).then((response) => {
                const user = response
                // this.setUser(user)
                this.validate()
                return user
            }).catch((error) => {
                notificationStore.error(error)

                throw error
            })
        },
        resetPassword({ email } = {}) {
            return getFirebaseBackend().forgetPassword(email).then((response) => {
                const message = response.data
                this.validate()

                return message
            }).catch((error) => {
                throw error
            });
        },
        logOut() {
            this.setUser(null)
            return new Promise((resolve, reject) => {
                getFirebaseBackend().logout().then(() => {
                    resolve(true);
                }).catch((error) => {
                    reject(this._handleError(error));
                })
            });
        },
    },
})
